import script from "./BlockArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlockArea.vue?vue&type=script&lang=ts&setup=true"

import "./BlockArea.vue?vue&type=style&index=0&id=5417084c&lang=scss"

const __exports__ = script;

export default __exports__